const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
const baseUrl = process.env.NODE_ENV === 'development' ? 'ws://localhost:8000/ws/' : `${wsProtocol}//www.vines.work/ws/`

// const baseUrl = `wss://www.vines.work/ws/`

class SocketService {
    static instance = null
    socket = null
    // reconnectAttempts = 0
    // maxReconnect = 5
    listeners = {}

    constructor() {
        if (SocketService.instance) {
            return SocketService.instance
        }
        SocketService.instance = this

        this.pingInterval = 30000
        this.pingTimer = null
    }

    connect(access_token) {
        if (this.socket) return

        // console.log(`Socket connecting`, `${baseUrl}stage/connect/${access_token}/`)
        this.socket = new WebSocket(`${baseUrl}stage/connect/${access_token}/`)

        this.socket.onopen = () => {
            console.log('socket connected')
            // this.reconnectAttempts = 0
            this.emit('connected')
            this.startHeartbeat()
        }

        this.socket.onmessage = (event) => {
            let data = null
            try {
                data = JSON.parse(event.data)
            } catch (e) {
                data = event.data
            }

            // console.log(`WebSocket onmessage type = ${typeof data} data = ${data}`)
            if (Object.keys(data).includes('type')) {
                const contentType = data['type']
                const contentText = data['text']
                if (contentType === 'pong') {
                    console.log('💓 pong')
                } else {
                    this.emit(contentType, contentText)
                }
            }
        }

        this.socket.onclose = () => {
            console.log('socket disconnected')
            this.emit('disconnected')
            // this.handleReconnect()
            this.socket = null
            // this.listeners = {}
        }

        this.socket.onerror = (error) => {
            console.error('socket error', error)
            this.emit('error', error)
            this.socket = null
            // this.listeners = {}
        }
    }

    on(event, callback) {
        // console.log('socket on', event)
        if (!this.listeners[event]) this.listeners[event] = []
        if (!this.listeners[event].includes(callback)) {
            this.listeners[event].push(callback)
        }
    }

    off(event, callback) {
        // console.log('socket off', event)
        if (this.listeners[event]) {
            this.listeners[event] = this.listeners[event].filter(fn => fn !== callback)
        }
    }

    removeAllListeners(event) {
        if (event) {
            delete this.listeners[event]
        } else {
            this.listeners = {}
        }
    }

    emit(event, ...args) {
        const callbacks = this.listeners[event] || []
        // console.log('socket emit', event, callbacks.length)
        callbacks.forEach(cb => cb(...args))
    }

    send(data) {
        if (this.socket?.readyState === WebSocket.OPEN) {
            const payload = typeof data === 'object' ? JSON.stringify(data) : data
            this.socket.send(payload)
        } else {
            console.warn(`WebSocket not connected, data = ${JSON.stringify(data)} not send`)
        }
    }

    startHeartbeat() {
        this.pingTimer = setInterval(() => {
            if (this.socket && this.socket?.readyState === WebSocket.OPEN) {
                // this.send('ping')
                this.send({'type': 'ping', 'text': ''})
            }
        }, this.pingInterval)
    }

    // handleReconnect () {
    // 	if (this.reconnectAttempts < this.maxReconnect) {
    // 		setTimeout(() => {
    // 			this.reconnectAttempts++
    // 			console.log(`Reconnecting (${this.reconnectAttempts}/${this.maxReconnect})...`)
    // 			this.connect()
    // 		}, 1000 * Math.min(this.reconnectAttempts, 5)) // 指数退避
    // 	}
    // }

    disconnect() {
        if (this.socket) {
            this.socket.close()
            this.socket = null
        }
        clearInterval(this.pingTimer)
    }
}

export const socketService = new SocketService()
